export const validateAccountEdit = (values) => {
  const errors = {};
  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];
  const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB
  // User Name
  if (!values.user_name.trim()) {
    errors.user_name = "User name is required";
  }

  // Father's Name
  if (values.father_name && !/^[a-zA-Z\s]+$/.test(values.father_name)) {
    errors.father_name = "Only letters allowed";
  }

  // Gender
  // if (!values.gender) {
  //   errors.gender = "Gender is required";
  // }

  // Email
  if (!values.email.trim()) {
    errors.email = "Email is required";
  }
  else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(values.email)) {
    errors.email = "Invalid email address";
  }
  else if (values.email.includes("..")) {
    errors.email = "Email cannot contain consecutive dots";
  }

  // Mobile
  if (!values.mobile.trim()) {
    errors.mobile = "Mobile number is required";
  }
  else if (!/^\d+$/.test(values.mobile)) {
    errors.mobile = "Mobile number must contain only numbers";
  }
  else if (!/^[0-9]{10}$/.test(values.mobile)) {
    errors.mobile = "Mobile number must be 10 digits";
  }

  // DOB
  // if (!values.dob) {
  //   errors.dob = "Date of birth is required";
  // }

  // Address
  // if (!values.street.trim()) {
  //   errors.street = "Street is required";
  // }

  if (!values.district) {
    errors.city = "City is required";
  }

  if (!values.state) {
    errors.state = "State is required";
  }

  if (!values.country.trim()) {
    errors.country = "Country is required";
  }

  // Zip
 if (values.zip && !/^[0-9]{6}$/.test(values.zip)) {
  errors.zip = "Pincode must be 6 digits";
}

  // ✅ PHOTO VALIDATION
  if (values.photo) {
    if (!ALLOWED_IMAGE_TYPES.includes(values.photo.type)) {
      errors.photo = "Only JPG, JPEG, and PNG files are allowed";
    } else if (values.photo.size > MAX_IMAGE_SIZE) {
      errors.photo = "Photo size must be less than 2MB";
    }
  }

  return errors;
};


export const validateResetPassword = (values) => {
  const errors = {};

  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 8) {
    errors.password = "Password must be at least 8 characters";
  } else if (!/[A-Z]/.test(values.password)) {
    errors.password = "Must contain one uppercase letter";
  } else if (!/[0-9]/.test(values.password)) {
    errors.password = "Must contain one number";
  } else if (!/[@$!%*?&]/.test(values.password)) {
    errors.password = "Must contain one special character";
  }

  if (!values.confirm_password) {
    errors.confirm_password = "Confirm password is required";
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = "Passwords do not match";
  }

  return errors;
};

